module.exports = __webpack_public_path__ + "static/media/president-nayeem-khan.4506712e.png";